(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  // Funktion zum Anzeigen des Pop-Ups
  function showNewsletterPopup() {
    document.getElementById('newsletter-popup').style.display = 'flex';
  }

  // Funktion zum Schließen des Pop-Ups
  function closeNewsletterPopup() {
    document.getElementById('newsletter-popup').style.display = 'none';
  }

	  document.addEventListener('DOMContentLoaded', function() {
    var $newsletterForm = $('.newsletter-form');
    
    // "submit" per AJAX abfangen
    $newsletterForm.on('submit', function(event) {
      event.preventDefault(); // Standard-Formular senden verhindern
      
      var $form = $(this);
      var actionUrl = $form.attr('action') || '/contact#contact_form';
      
      // Optional: Vorher alte Fehlermeldungen entfernen, falls vorhanden
      $form.find('.newsletter-form__message').remove();
      
      $.ajax({
        type: $form.attr('method') || 'POST',
        url: actionUrl,
        data: $form.serialize(),
        success: function(response) {
          // Hier müsste man eigentlich die Antwort checken, ob "erfolgreich" o.Ä.
          // Für das Beispiel nehmen wir an, es hat geklappt:
          showNewsletterPopup();
        },
	        error: function() {
	          var message = document.createElement('small');
	          message.className = 'newsletter-form__message form__message';
	          message.style.color = 'red';
	          message.textContent = 'Oops, something went wrong. Please try again.';
	          $form.append(message);
	        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levyo-group-shirt-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('LevyoProofRequestForm');

    if (!form) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const fields = {
      page_url: window.location.href,
      referrer: document.referrer,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      utm_term: params.get('utm_term') || '',
      source: params.get('source') || params.get('ref') || ''
    };

    Object.entries(fields).forEach(([key, value]) => {
      const input = form.querySelector(`[data-levyo-source-field="${key}"]`);

      if (input) {
        input.value = value;
      }
    });

    const uploadRoot = form.querySelector('[data-proof-upload]');
    const uploadInput = form.querySelector('[data-proof-upload-input]');
    const uploadTrigger = form.querySelector('[data-proof-upload-trigger]');
    const uploadLinksInput = form.querySelector('[data-proof-upload-links]');
    const uploadStatus = form.querySelector('[data-proof-upload-status]');
    const uploadList = form.querySelector('[data-proof-upload-list]');
    const submitButton = form.querySelector('.levyo-proof__submit');
    const uploadConfig = document.querySelector('[data-proof-upload-config]');

    if (!uploadRoot || !uploadInput || !uploadTrigger || !uploadLinksInput || !uploadList) {
      return;
    }

    const SHOP_DOMAIN = uploadConfig ? (uploadConfig.dataset.shopDomain || '') : '';
    const host = window.location.hostname || '';
    const serviceBase = window.CUSTOMERREGISTER_BASE || (host.endsWith('socialloginsuite.com')
      ? 'https://auth.socialloginsuite.com'
      : (host.endsWith('levyo.co.uk') ? 'https://auth.levyo.co.uk' : 'https://auth.threadlyclo.com'));
    const maxUploadBytes = 8 * 1024 * 1024;
    const maxUploadCount = 4;
    const uploadedFiles = [];
    let activeUploads = 0;

    const uploadStrings = {
      uploading: uploadConfig ? (uploadConfig.dataset.uploadStatusUploading || 'Uploading image...') : 'Uploading image...',
      uploaded: uploadConfig ? (uploadConfig.dataset.uploadStatusUploaded || 'Image uploaded.') : 'Image uploaded.',
      waiting: uploadConfig ? (uploadConfig.dataset.uploadStatusWaiting || 'Please wait until the upload finishes before sending.') : 'Please wait until the upload finishes before sending.',
      type: uploadConfig ? (uploadConfig.dataset.uploadErrorType || 'Please upload a PNG, JPG, or WEBP image.') : 'Please upload a PNG, JPG, or WEBP image.',
      size: uploadConfig ? (uploadConfig.dataset.uploadErrorSize || 'One image is too large.') : 'One image is too large.',
      count: uploadConfig ? (uploadConfig.dataset.uploadErrorCount || 'Please upload no more than 4 images.') : 'Please upload no more than 4 images.',
      failed: uploadConfig ? (uploadConfig.dataset.uploadErrorFailed || 'Upload failed.') : 'Upload failed.',
      remove: uploadConfig ? (uploadConfig.dataset.uploadRemove || 'Remove') : 'Remove'
    };

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function setUploadStatus(message, isError) {
      if (!uploadStatus) {
        return;
      }

      uploadStatus.textContent = message || '';
      uploadStatus.classList.toggle('is-error', Boolean(isError));
    }

    function setUploadingState(delta) {
      activeUploads = Math.max(0, activeUploads + delta);
      uploadRoot.classList.toggle('is-uploading', activeUploads > 0);
      uploadTrigger.disabled = activeUploads > 0;

      if (submitButton) {
        submitButton.disabled = activeUploads > 0;
      }
    }

    function syncUploadedLinks() {
      uploadLinksInput.value = uploadedFiles
        .map((item, index) => `${index + 1}. ${item.name}: ${item.url}`)
        .join('\n');
    }

    function renderUploadedFiles() {
      uploadList.innerHTML = uploadedFiles.map((item, index) => `
        <li class="levyo-proof__upload-item">
          <span class="levyo-proof__upload-name">${escapeHtml(item.name)}</span>
          <button type="button" class="levyo-proof__upload-remove" data-proof-upload-remove="${index}">
            ${escapeHtml(uploadStrings.remove)}
          </button>
        </li>
      `).join('');
      syncUploadedLinks();
    }

    function validateProofFile(file) {
      if (!file) {
        return uploadStrings.failed;
      }

      if (!/^image\/(png|jpe?g|webp)$/i.test(file.type || '')) {
        return uploadStrings.type;
      }

      if (file.size > maxUploadBytes) {
        return uploadStrings.size;
      }

      return '';
    }

    async function readJsonResponse(response, fallbackMessage) {
      let data = {};
      try {
        data = await response.json();
      } catch (_error) {
        data = {};
      }

      if (!response.ok || !data.success) {
        throw new Error(fallbackMessage);
      }

      return data;
    }

    async function uploadProofFile(file) {
      const startResponse = await fetch(`${serviceBase}/proofRequestUpload/start`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-shop-domain': SHOP_DOMAIN
        },
        body: JSON.stringify({
          contentType: file.type,
          fileName: file.name
        })
      });
      const start = await readJsonResponse(startResponse, uploadStrings.failed);

      if (!start.uploadUrl || !start.objectPath) {
        throw new Error(uploadStrings.failed);
      }

      const putResponse = await fetch(start.uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type
        },
        body: file
      });

      if (!putResponse.ok) {
        throw new Error(uploadStrings.failed);
      }

      const commitResponse = await fetch(`${serviceBase}/proofRequestUpload/commit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-shop-domain': SHOP_DOMAIN
        },
        body: JSON.stringify({
          objectPath: start.objectPath,
          fileName: file.name
        })
      });
      const commit = await readJsonResponse(commitResponse, uploadStrings.failed);

      if (!commit.publicUrl) {
        throw new Error(uploadStrings.failed);
      }

      return {
        name: commit.fileName || file.name,
        url: commit.publicUrl
      };
    }

    async function handleSelectedFiles(files) {
      const chosenFiles = Array.from(files || []);

      if (!chosenFiles.length) {
        return;
      }

      if (uploadedFiles.length + chosenFiles.length > maxUploadCount) {
        setUploadStatus(uploadStrings.count, true);
        return;
      }

      setUploadingState(1);
      setUploadStatus(uploadStrings.uploading, false);

      try {
        for (const file of chosenFiles) {
          const validationError = validateProofFile(file);

          if (validationError) {
            throw new Error(validationError);
          }

          const uploaded = await uploadProofFile(file);
          uploadedFiles.push(uploaded);
          renderUploadedFiles();
        }

        setUploadStatus(uploadStrings.uploaded, false);
      } catch (error) {
        setUploadStatus(error && error.message ? error.message : uploadStrings.failed, true);
      } finally {
        setUploadingState(-1);
        uploadInput.value = '';
      }
    }

    uploadTrigger.addEventListener('click', () => {
      uploadInput.click();
    });

    uploadInput.addEventListener('change', () => {
      handleSelectedFiles(uploadInput.files);
    });

    uploadList.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-proof-upload-remove]');

      if (!removeButton) {
        return;
      }

      const index = Number(removeButton.getAttribute('data-proof-upload-remove'));

      if (Number.isInteger(index) && index >= 0) {
        uploadedFiles.splice(index, 1);
        renderUploadedFiles();
        setUploadStatus('', false);
      }
    });

    form.addEventListener('submit', (event) => {
      if (activeUploads > 0) {
        event.preventDefault();
        setUploadStatus(uploadStrings.waiting, true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levyo-target-proof-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.levyo-target-proof__form').forEach((form) => {
      const params = new URLSearchParams(window.location.search);
      const fields = {
        page_url: window.location.href,
        referrer: document.referrer,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_content: params.get('utm_content') || '',
        utm_term: params.get('utm_term') || '',
        source: params.get('source') || params.get('ref') || ''
      };

      Object.entries(fields).forEach(([key, value]) => {
        const input = form.querySelector(`[data-levyo-source-field="${key}"]`);

        if (input) {
          input.value = value;
        }
      });

      const section = form.closest('.levyo-target-proof');
      const uploadRoot = form.querySelector('[data-proof-upload]');
      const uploadInput = form.querySelector('[data-proof-upload-input]');
      const uploadTrigger = form.querySelector('[data-proof-upload-trigger]');
      const uploadLinksInput = form.querySelector('[data-proof-upload-links]');
      const uploadStatus = form.querySelector('[data-proof-upload-status]');
      const uploadList = form.querySelector('[data-proof-upload-list]');
      const submitButton = form.querySelector('.levyo-target-proof__submit');
      const uploadConfig = section ? section.querySelector('[data-proof-upload-config]') : null;

      if (!uploadRoot || !uploadInput || !uploadTrigger || !uploadLinksInput || !uploadList) {
        return;
      }

      const SHOP_DOMAIN = uploadConfig ? (uploadConfig.dataset.shopDomain || '') : '';
      const host = window.location.hostname || '';
      const serviceBase = window.CUSTOMERREGISTER_BASE || (host.endsWith('socialloginsuite.com')
        ? 'https://auth.socialloginsuite.com'
        : (host.endsWith('levyo.co.uk') ? 'https://auth.levyo.co.uk' : 'https://auth.threadlyclo.com'));
      const maxUploadBytes = 8 * 1024 * 1024;
      const maxUploadCount = 4;
      const uploadedFiles = [];
      let activeUploads = 0;

      const uploadStrings = {
        uploading: uploadConfig ? (uploadConfig.dataset.uploadStatusUploading || 'Uploading image...') : 'Uploading image...',
        uploaded: uploadConfig ? (uploadConfig.dataset.uploadStatusUploaded || 'Image uploaded.') : 'Image uploaded.',
        waiting: uploadConfig ? (uploadConfig.dataset.uploadStatusWaiting || 'Please wait until the upload finishes before sending.') : 'Please wait until the upload finishes before sending.',
        type: uploadConfig ? (uploadConfig.dataset.uploadErrorType || 'Please upload a PNG, JPG or WEBP image.') : 'Please upload a PNG, JPG or WEBP image.',
        size: uploadConfig ? (uploadConfig.dataset.uploadErrorSize || 'One image is too large.') : 'One image is too large.',
        count: uploadConfig ? (uploadConfig.dataset.uploadErrorCount || 'Please upload no more than 4 images.') : 'Please upload no more than 4 images.',
        failed: uploadConfig ? (uploadConfig.dataset.uploadErrorFailed || 'Upload failed.') : 'Upload failed.',
        remove: uploadConfig ? (uploadConfig.dataset.uploadRemove || 'Remove') : 'Remove'
      };

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function setUploadStatus(message, isError) {
        if (!uploadStatus) {
          return;
        }

        uploadStatus.textContent = message || '';
        uploadStatus.classList.toggle('is-error', Boolean(isError));
      }

      function setUploadingState(delta) {
        activeUploads = Math.max(0, activeUploads + delta);
        uploadRoot.classList.toggle('is-uploading', activeUploads > 0);
        uploadTrigger.disabled = activeUploads > 0;

        if (submitButton) {
          submitButton.disabled = activeUploads > 0;
        }
      }

      function syncUploadedLinks() {
        uploadLinksInput.value = uploadedFiles
          .map((item, index) => `${index + 1}. ${item.name}: ${item.url}`)
          .join('\n');
      }

      function renderUploadedFiles() {
        uploadList.innerHTML = uploadedFiles.map((item, index) => `
          <li class="levyo-target-proof__upload-item">
            <span class="levyo-target-proof__upload-name">${escapeHtml(item.name)}</span>
            <button type="button" class="levyo-target-proof__upload-remove" data-proof-upload-remove="${index}">
              ${escapeHtml(uploadStrings.remove)}
            </button>
          </li>
        `).join('');
        syncUploadedLinks();
      }

      function validateProofFile(file) {
        if (!file) {
          return uploadStrings.failed;
        }

        if (!/^image\/(png|jpe?g|webp)$/i.test(file.type || '')) {
          return uploadStrings.type;
        }

        if (file.size > maxUploadBytes) {
          return uploadStrings.size;
        }

        return '';
      }

      async function readJsonResponse(response, fallbackMessage) {
        let data = {};
        try {
          data = await response.json();
        } catch (_error) {
          data = {};
        }

        if (!response.ok || !data.success) {
          throw new Error(fallbackMessage);
        }

        return data;
      }

      async function uploadProofFile(file) {
        const startResponse = await fetch(`${serviceBase}/proofRequestUpload/start`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-shop-domain': SHOP_DOMAIN
          },
          body: JSON.stringify({
            contentType: file.type,
            fileName: file.name
          })
        });
        const start = await readJsonResponse(startResponse, uploadStrings.failed);

        if (!start.uploadUrl || !start.objectPath) {
          throw new Error(uploadStrings.failed);
        }

        const putResponse = await fetch(start.uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': file.type
          },
          body: file
        });

        if (!putResponse.ok) {
          throw new Error(uploadStrings.failed);
        }

        const commitResponse = await fetch(`${serviceBase}/proofRequestUpload/commit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-shop-domain': SHOP_DOMAIN
          },
          body: JSON.stringify({
            objectPath: start.objectPath,
            fileName: file.name
          })
        });
        const commit = await readJsonResponse(commitResponse, uploadStrings.failed);

        if (!commit.publicUrl) {
          throw new Error(uploadStrings.failed);
        }

        return {
          name: commit.fileName || file.name,
          url: commit.publicUrl
        };
      }

      async function handleSelectedFiles(files) {
        const chosenFiles = Array.from(files || []);

        if (!chosenFiles.length) {
          return;
        }

        if (uploadedFiles.length + chosenFiles.length > maxUploadCount) {
          setUploadStatus(uploadStrings.count, true);
          return;
        }

        setUploadingState(1);
        setUploadStatus(uploadStrings.uploading, false);

        try {
          for (const file of chosenFiles) {
            const validationError = validateProofFile(file);

            if (validationError) {
              throw new Error(validationError);
            }

            const uploaded = await uploadProofFile(file);
            uploadedFiles.push(uploaded);
            renderUploadedFiles();
          }

          setUploadStatus(uploadStrings.uploaded, false);
        } catch (error) {
          setUploadStatus(error && error.message ? error.message : uploadStrings.failed, true);
        } finally {
          setUploadingState(-1);
          uploadInput.value = '';
        }
      }

      uploadTrigger.addEventListener('click', () => {
        uploadInput.click();
      });

      uploadInput.addEventListener('change', () => {
        handleSelectedFiles(uploadInput.files);
      });

      uploadList.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-proof-upload-remove]');

        if (!removeButton) {
          return;
        }

        const index = Number(removeButton.getAttribute('data-proof-upload-remove'));

        if (Number.isInteger(index) && index >= 0) {
          uploadedFiles.splice(index, 1);
          renderUploadedFiles();
          setUploadStatus('', false);
        }
      });

      form.addEventListener('submit', (event) => {
        if (activeUploads > 0) {
          event.preventDefault();
          setUploadStatus(uploadStrings.waiting, true);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
